module.exports = __webpack_public_path__ + "sk-trip-wizard-mockup-with-shadow.BpUn2g5w.png";